import React, { useState } from 'react'
import { Box, FormHelperText, Grid, IconButton, InputAdornment, TextField } from '@mui/material'
import '../styles/rangeDenomination.css'
import { handleAmount } from '../../../shared/extra';
import { addNewDenomination } from '../../../store/productDetails/action';
import { useDispatch, useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';

const RangeDenomination = () => {
    const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
    const [inputError, setInputError] = useState(false);
    const [inputErrorMessage, SetInputErrorMessage] = useState('')
    const [userAmt, setUserAmt] = useState(null);
    const dispatch = useDispatch();
    const DENOMINATION_STORE_DATA = useSelector((state) => state.Denominations?.allData);


    const handleRangeDenomination = () => {
        if (userAmt >= PRODUCTDETAILS?.min_price && userAmt <= PRODUCTDETAILS?.max_price) {
            const amtStatus = checkDuplicateDenomination();

            if (amtStatus) {
                handleRangeDenominationData(dispatch);
            } else {
                setInputError(true);
                SetInputErrorMessage("Duplicate Denomination Amount!")
            }
        } else {
            setInputError(true);
            SetInputErrorMessage("Invalid Denomination Amount!")
        }
    }
    // Set Range Amount
    // const handleRangeInput = (e) => {
    //     setUserAmt(e?.target?.value.replace(/\D/g, ''));
    //     if (inputError) {
    //         setInputError(false);
    //         SetInputErrorMessage('');
    //     }
    // }

    const handleRangeInput = (e) => {
        const rawValue = e?.target?.value;
        const onlyDigits = rawValue.replace(/\D/g, '');

        // Convert to number for comparison
        const numericValue = Number(onlyDigits);

        if (numericValue > PRODUCTDETAILS?.max_price) {
            setInputError(true);
            SetInputErrorMessage(`Denomination max limit ${handleAmount(PRODUCTDETAILS?.max_price)} Rs`);
            return;
        }

        setUserAmt(onlyDigits);

        if (inputError) {
            setInputError(false);
            SetInputErrorMessage('');
        }
    };


    return (
        <Grid container
            sx={{
                width: {
                    xs: "100%",
                    sm: "100%",
                    lg: "100%"
                },
                px: 1,
                my: {
                    lg: 1
                },
                py: { sm: 2, lg: 0 },
                backgroundColor: "white.main",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 2,
            }}>

            <Grid item xs={12} lg={12}>
                <Box
                    sx={{
                        py: { lg: 0 },
                        px: { lg: 1 },
                        display: "flex",
                        flexDirection: { sm: "column", lg: 'column' },
                        justifyContent: { lg: "center" },
                        minHeight: { xs: "80px", sm: "65px", lg: "90px" },
                    }}>

                    <TextField
                        variant="standard"
                        placeholder={`${handleAmount(PRODUCTDETAILS?.min_price)} Rs to ${handleAmount(PRODUCTDETAILS?.max_price)} Rs`}
                        inputProps={{
                            maxLength: PRODUCTDETAILS?.max_price.toString()?.length+1,
                            max: PRODUCTDETAILS?.max_price,
                            sx: {
                                py: "10.5px",
                                fontSize: {
                                    xs: "1.4rem",
                                    lg: "2rem",
                                },
                                letterSpacing: {
                                    xs: "6px",
                                    lg: "6px"
                                },
                                color: {
                                    xs: "primary.main",
                                    lg: "primary.main",
                                },
                            },
                        }}
                        pattern="\d{6}"
                        value={userAmt ? handleAmount(userAmt) : ''}
                        onChange={(e) => handleRangeInput(e)}
                        fullWidth
                        sx={{
                            minHeight: { xs: "40px", md: '40px', lg: "35px" },
                            textIndent: { xs: "5px", md: '15px', lg: "10px" },
                        }}
                        error={inputError}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="add denomination"
                                        onClick={handleRangeDenomination}
                                        edge="end"
                                        sx={{
                                            backgroundColor: "lightSecondary.main",
                                            color: "primary.main",
                                            "&: hover": {
                                                backgroundColor: "#c0d6f8",
                                            }
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx: {
                                borderRadius: 6,
                                pr: 3,
                                "&: hover": {
                                    border: 0,
                                }
                            }
                        }}
                    />

                    <FormHelperText sx={{
                        fontSize: "11.5px",
                        color: inputErrorMessage ? "error.main" : "textPrimary.main",
                        fontWeight: inputErrorMessage ? 400 : 500,
                        textTransform: "capitalize",
                    }}>
                        {inputErrorMessage || `Denominations must range from ${handleAmount(PRODUCTDETAILS?.min_price)} Rs to ${handleAmount(PRODUCTDETAILS?.max_price)} Rs`}
                    </FormHelperText>
                </Box>
            </Grid>
        </Grid>
    )

    function handleRangeDenominationData(dispatch) {
        const productId = PRODUCTDETAILS?.['id'];

        if (productId) {
            const denominationObject = {
                "AMOUNT": userAmt,
                "DISCOUNT": PRODUCTDETAILS['discount'],
                "QUANTITY": 1,
                "TOTAL": parseInt(userAmt * 1),
                "PRODUCT_CODE": null,
                "PRODUCT_GUID": null,
                "PRODUCT_ID": null,
                "SUB_PRODUCT_ID": null,
                "SKU_ID": null
            };
            dispatch(addNewDenomination(denominationObject));
            setUserAmt('');
        }
    }

    function checkDuplicateDenomination() {
        if (DENOMINATION_STORE_DATA?.length > 0) {
            const amounts = DENOMINATION_STORE_DATA?.map(item => item.AMOUNT);
            const occurrences = amounts.filter(itemAmount => itemAmount === userAmt).length;
            return !occurrences >= 1;
        }
        return true;
    }
}

export default RangeDenomination;

